import { lazy, Suspense } from 'react'

/*
 * The Query and Router devtools, **in dev only**.
 *
 * `import.meta.env.DEV` is a build-time constant: in production the branch is dead and the
 * two dynamic imports are not even emitted as chunks. That is why they are lazy rather than
 * static imports — otherwise they would land in the bundle graph and in §6's budget.
 */

const LazyQueryDevtools = lazy(async () => {
  const form = await import('@tanstack/react-query-devtools')
  return { default: form.ReactQueryDevtools }
})

const LazyRouterDevtools = lazy(async () => {
  const form = await import('@tanstack/react-router-devtools')
  return { default: form.TanStackRouterDevtools }
})

/** Query's devtools: they live next to the `QueryClientProvider`. */
export function QueryDevtools() {
  if (!import.meta.env.DEV) return null

  return (
    <Suspense fallback={null}>
      <LazyQueryDevtools initialIsOpen={false} />
    </Suspense>
  )
}

/**
 * The router devtools. They have to be mounted INSIDE the route tree: they read state with
 * `useRouterState`, which outside the `RouterProvider` finds null and takes the app down
 * with a blank page.
 */
export function RouterDevtools() {
  if (!import.meta.env.DEV) return null

  return (
    <Suspense fallback={null}>
      <LazyRouterDevtools position="bottom-right" />
    </Suspense>
  )
}
